<template>
    <zen-one
        :showuserinfo="false"
        :crumbs="crumbs"
        title="Sistem Hasil Bersepadu Kedah (iHasil)"
    >
        <div class="message-box">
            <w-transition-fade>
                <w-alert
                    class="my0 text-light"
                    v-if="form.submitted"
                    success
                    no-border
                >
                    The form is valid, ready to send it!
                </w-alert>

                <w-alert
                    class="my0 text-light"
                    v-else-if="form.valid === false"
                    error
                    no-border
                >
                    Terdapat {{ form.errorsCount }} ralat di dalam borang ini.
                </w-alert>
            </w-transition-fade>
        </div>

        <z-page title="Carian">
            <w-flex justify-center align-center>
                <div class="xs4">
                    <w-input
                        label="No Bank"
                        v-model="payment_id"
                    >
                    </w-input>
                </div>
                <div class="xs8">
                    <w-button class="ml1" @click="cari"
                        >Cari</w-button
                    >
                </div>
            </w-flex>
        </z-page>
        <z-page title="Transaksi Bank" v-if="c == 1">
            <w-flex justify-center align-center class="mt5">
                <div class="w-card__content content-hardcode">
                     <table class="table-dashboard" width="100%">
                        <thead>
                            <tr>
                                <th>No</th>
                                <th>No Bank</th>
                                <th>No Order</th>
                                <th>Tarikh Bayar</th>
                                <th>Amaun (RM) </th>
                                <tr></tr>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="dt, index in troli">
                               <td align="center">{{(index+1)}}</td>
                               <td>{{dt.payment_id}}</td>
                               <td>{{dt.order_id}}</td>
                               <td>{{dt.tarikh_bayar}}</td>
                               <td align="right">{{$zutil.currency(dt.total_bayar)}}</td>
                               <td align="center">
                                   <w-button class="my1 " v-if= 'pay.status == 4 && jana == 1' @click="janaResit()">Jana Resit</w-button>
                               </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </w-flex>
        </z-page>
        <!-- <z-page title="Kedah Pay" v-if="c == 1">
        </z-page> -->
        <z-page title="Resit Ibayaq" v-if="c == 1">
             <w-flex justify-center align-center class="mt5">
                <div class="w-card__content content-hardcode">
                     <table class="table-dashboard" width="100%">
                        <thead>
                            <tr>
                                <th>No</th>
                                <th>No Bank</th>
                                <th>No Resit </th>
                                <th>No Rujukan | Nama</th>
                                <th>Tarikh Bayar</th>
                                <th>Amaun (RM) </th>
                                <th>Status </th>
                                <tr></tr>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="dt, index in resit">
                               <td align="center">{{(index+1)}}</td>
                               <td>{{dt.payment_id}}</td>
                               <td>{{dt.no_resit}}</td>
                               <td>{{dt.rujukan}}</td>
                               <td>{{dt.tarikh_bayar}}</td>
                               <td align="right">{{$zutil.currency(dt.amaun)}}</td>
                               <td>{{dt.status_resit}}</td>
                               <td align="center">
                                <a :href='dt.cetak'>
                        <w-tooltip top>
                           <template #activator="{ on }">
                             <w-icon v-on="on" >
                               fal fa-print
                             </w-icon>
                           </template>
                           Cetak
                         </w-tooltip>
                        </a>
                                   <!-- <w-button class="my1 " v-if= 'pay.status == 4' @click="jana()">Jana Resit</w-button> -->
                               </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </w-flex>
        </z-page>

    </zen-one>
</template>

<script>
import ZResource from "@/Modules/z-resource-service";

export default {
    extends: ZResource,
    components: {},
    props: {
        id: [Array, Object, String],
    },
    data() {
        return {
            
            troli : [],
            pay : {},
            resit : [],
            payment_id : '',
            form : {},
            jana : 0,
            c : 0,
            crumbs: [
                { label: "iHasil", route: "/" },
                { label: "IBayaq", route: "/ibayaq" },
                { label: "Jana Resit", route: "/kutipan/ibayaq/troli" },
            ],
        };
    },
    
    

    methods: {

        
        cari() {
            // if(this.payment_id > 0){
        if (this.payment_id && this.payment_id.trim() !== '') {
            this.$zcomm
                .get(this.service_kutipan + "troli/" + this.payment_id)
                .then((res) => {
                    if(res.pay.payment_id){
                        this.c = 1
                        this.jana = res.jana
                        this.troli = res.troli
                        this.pay = res.pay
                        this.resit = res.resit
                    }
                   
                });
            }   
        },
        janaResit(){
            // if(this.payment_id > 0){
        if (this.payment_id && this.payment_id.trim() !== '') {
            this.$zcomm
                .post( "https://ibayaq.kedah.gov.my/api/resit/baharu", this.pay)
                .then((res) => {
                    this.cari()
                   
                });
            }   
        },

        getData(){}
    },
    watch: {
       

    },
    mounted() {}
        
    
    };
</script>
